module.exports = __webpack_public_path__ + "img/110.bd832d2f.jpg";